export const CUSTOMER_DISPLAY_LOCK_STATUS = Object.freeze({
  acquired: 'acquired',
  unavailable: 'unavailable',
  unsupported: 'unsupported',
  failed: 'failed',
})

const DEFAULT_LOCK_TIMEOUT_MS = 1000

export const acquireExclusiveCustomerDisplayLock = (
  lockName,
  { timeoutMs = DEFAULT_LOCK_TIMEOUT_MS } = {}
) => {
  const lockManager = globalThis.navigator?.locks
  if (typeof lockManager?.request !== 'function') {
    return Promise.resolve({
      status: CUSTOMER_DISPLAY_LOCK_STATUS.unsupported,
    })
  }

  return new Promise(resolve => {
    let settled = false
    const abortController = globalThis.AbortController
      ? new globalThis.AbortController()
      : null

    const finish = result => {
      if (settled) return false

      settled = true
      globalThis.clearTimeout(timeoutId)
      resolve(result)
      return true
    }

    const timeoutId = globalThis.setTimeout(() => {
      if (
        finish({
          status: CUSTOMER_DISPLAY_LOCK_STATUS.failed,
          reason: 'timeout',
        })
      ) {
        abortController?.abort()
      }
    }, timeoutMs)

    const options = {
      mode: 'exclusive',
      ifAvailable: true,
      ...(abortController && { signal: abortController.signal }),
    }

    try {
      Promise.resolve(
        lockManager.request(lockName, options, async lock => {
          if (!lock) {
            finish({ status: CUSTOMER_DISPLAY_LOCK_STATUS.unavailable })
            return
          }

          let releaseLock
          const lockHeld = new Promise(resolve => {
            releaseLock = resolve
          })

          if (
            !finish({
              status: CUSTOMER_DISPLAY_LOCK_STATUS.acquired,
              release: releaseLock,
            })
          ) {
            releaseLock()
            return
          }

          await lockHeld
        })
      ).catch(error => {
        if (settled && error?.name === 'AbortError') return

        finish({
          status: CUSTOMER_DISPLAY_LOCK_STATUS.failed,
          error,
        })
      })
    } catch (error) {
      finish({
        status: CUSTOMER_DISPLAY_LOCK_STATUS.failed,
        error,
      })
    }
  })
}
